/**
 * @generated SignedSource<<92c5956fe30011668a800e37b0a6b768>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedPartialItemsPlaceholder_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedProductAdWrapper_itemSearch">;
  readonly " $fragmentType": "SbSharedPartialItemsPlaceholder_itemSearch";
};
export type SbSharedPartialItemsPlaceholder_itemSearch$key = {
  readonly " $data"?: SbSharedPartialItemsPlaceholder_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedPartialItemsPlaceholder_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedPartialItemsPlaceholder_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedProductAdWrapper_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "7debb7edf9b9270b3132f2c5428fca64";

export default node;
